// @ts-expect-error [TS migration] Was not detected by flow
import React, { Node } from 'react';
import DatePicker from 'components/inputs/DatePicker';

type Props = {
    filter: SentenceFilterT;
    setFilter: FlowAnyFunction;
    isPerimeterFilter?: boolean;
    isDisabled?: boolean;
    children: Node;
    shouldDebounce: boolean;
};
function RegularDatePicker({
    children,
    isPerimeterFilter,
    isDisabled,
    filter,
    setFilter,
    shouldDebounce,
}: Props): Node {
    if (isPerimeterFilter && !filter.value) return children;
    return (
        <>
            {children}

            <DatePicker
                disabled={isDisabled}
                key="filter-date-picker"
                value={filter.value}
                onChange={(value) => setFilter({ value })}
                fullWidth={isPerimeterFilter}
                shouldDebounce={shouldDebounce}
                InputProps={{ disableUnderline: true }}
            />
        </>
    );
}
export default RegularDatePicker;
